import { useMemo } from 'react';

import { RetailsPlaceholder } from '@telialt/core-retails/src/components/RetailsPlaceholder';
import { StockLevelStatuses } from '@telialt/models/src/EshopModel';
import { cloneDeep } from '@telialt/utils/src/helpers';

import { useBaseProductFromUrlParam } from '../../../hooks/useBaseProductFromUrlParam';

export const ProductRetailsPlaceholder = () => {
    const { baseProduct } = useBaseProductFromUrlParam();

    const inStockMatrix = useMemo(() => {
        const matrices = cloneDeep(baseProduct.variantMatrix);
        const stack = [...matrices];
        while (stack.length) {
            const matrix = stack.pop();
            matrix.variantOption.stock.stockLevelStatus = StockLevelStatuses.InStock;
            if (matrix.elements.length) {
                stack.push(...matrix.elements);
            }
        }

        return matrices;
    }, [baseProduct.variantMatrix]);

    return <RetailsPlaceholder baseProductCode={baseProduct.code} variantMatrix={inStockMatrix} />;
};
